const state = {
    logo: require('../../assets/images/auto-service-22266879.png'),
    phone: require('../../assets/images/phone-1.png'),
    phone2: require('../../assets/images/phone-2.png'),
    phone1: require('../../assets/images/phone-3.png'),
    phone11: require('../../assets/images/phone-11.png'),
    dashlaptop: require('../../assets/images/542.png'),
    phonedownalod: require('../../assets/images/phone-4.png'),
    phonedownalod2: require('../../assets/images/phone-5.png'),
    back: require('../../assets/images/back.jpg'),
    dash1: require('../../assets/images/dashbord-1.jpg'),
    dash2: require('../../assets/images/dashbord-2.jpg'),
    dash3: require('../../assets/images/dashbord-3.jpg'),
    dash4: require('../../assets/images/dashbord-4.jpg'),
    downloadphone: require('../../assets/images/downloadphone.png'),
    downloadphone1: require('../../assets/images/downloadphone1.png'),
    background1: require('../../assets/images/image-shap-1.png'),
    background2: require('../../assets/images/image-shap-2.png'),
    price1: require('../../assets/images/price1.png'),
    price2: require('../../assets/images/price2.png'),
    shap: require('../../assets/images/shap-3.png'),
    review1: require('../../assets/images/review1.jpg'),
    review2: require('../../assets/images/review2.jpg'),
    review3: require('../../assets/images/review3.jpg'),
    review4: require('../../assets/images/review4.jpg'),
    review5: require('../../assets/images/review5.jpg'),
    asabyarLogo: require('../../assets/images/asabyar.png'),
    asayabLogo: require('../../assets/images/asayab.png'),
    jobcareLogo: require('../../assets/images/job care.png'),
    asayarLogo: require('../../assets/images/asayar.png'),
    company: require('../../assets/images/company.jpg'),
}
const getters = {
}
const mutations = {
}
const actions = {
}
export default {
    mutations,
    getters,
    state,
    actions
};